export default __webpack_public_path__ + "static/media/group-8448.3886b53c.png";